
const Cell = (props) => {
  const {
    day,
    start,
    end,
    editable,
    height,
    children,
    showScheduleModal,
    setShowScheduleModal,
    isClosedToday,
    isBreakNow
  }= props;


  if (!editable) return null;


const getDockColors = (dockList = []) => {
  const colors = [
    ...new Set(dockList.map(item => item.dockColor || "#E39898").filter(Boolean))
  ].slice(0, 5);

  if (!colors.length) {
    return 'linear-gradient(90deg, #E39898 0% 100%)';
  }

  const step = 100 / colors.length;

  const gradientStops = colors.map((color, index) => {
    const start = step * index;
    const end = step * (index + 1);
    return `${color} ${start}% ${end}%`;
  });

  return `linear-gradient(90deg, ${gradientStops.join(', ')})`;
};



  return (
  <>
   <button style={(isClosedToday && isClosedToday.length) ?{background:getDockColors(isClosedToday),border:"none"}:{background:"none",border:"none"}} onClick={()=>{setShowScheduleModal(true)}}>
   </button>

    </>
  );
};

export default Cell;
